// 문서 내 목차. 스크롤 위치에 따라 현재 섹션을 강조한다
import { useEffect, useState } from 'react';
import { HashLink } from 'react-router-hash-link';
import { scrollWithOffset } from '../../../util/HelperFunctions';
import classes from './DescriptionPageTemplate.module.css';

// 공통 헤더 높이(--header-h). 앵커 이동 시 이만큼 위를 비운다. SearchModal 과 같은 값이다
const HEADER_OFFSET = 80;

/**
 * 문서 내 목차.
 *
 * items 는 렌더된 섹션에서 만들어 넘긴다. 문서마다 있는 섹션이 달라
 * (Query 가 없는 문서, Response 가 없는 문서) 목록을 고정하면 없는 앵커로 점프한다.
 *
 * @param {Array<{id: string, label: string, sub?: boolean}>} items
 */
const DocToc = ({ items }) => {
  const [activeId, setActiveId] = useState(items[0]?.id);

  useEffect(() => {
    // jsdom 등 IntersectionObserver 가 없는 환경에서는 강조 없이 목차만 보여준다
    if (typeof IntersectionObserver === 'undefined') return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) setActiveId(entry.target.id);
        });
      },
      { rootMargin: '0px 0px -75% 0px' }
    );

    const targets = items
      .map((item) => document.getElementById(item.id))
      .filter(Boolean);
    targets.forEach((target) => observer.observe(target));

    return () => observer.disconnect();
  }, [items]);

  if (items.length === 0) return null;

  return (
    <aside className={classes.toc}>
      <div className={classes.tocLabel}>이 문서</div>
      <nav>
        {items.map((item) => {
          const base = item.sub ? `${classes.tocLink} ${classes.tocLinkSub}` : classes.tocLink;
          return (
            // 생 <a href="#id"> 를 쓰면 안 된다. 브라우저 네이티브 앵커 점프는
            // 헤더(sticky 80px) 아래로 가리고, DetailLoadingPage 가 재마운트하는 순간
            // 대상이 사라져 실패한다. HashLink 는 대상이 나타날 때까지 기다려 스크롤한다.
            // SearchModal 과 같은 이동 방식이다
            <HashLink
              key={item.id}
              to={`#${item.id}`}
              scroll={(el) => scrollWithOffset(el, HEADER_OFFSET)}
              className={item.id === activeId ? `${base} ${classes.tocLinkActive}` : base}
            >
              {item.label}
            </HashLink>
          );
        })}
      </nav>
    </aside>
  );
};

export default DocToc;
